<template>
    <div>
        <navbar></navbar>
        <div class="container pt-4">
            <h1>Kroužky</h1>
            <h5>Tento týden je <b>{{ week() }}</b></h5>
            <ul class="mt-3">
                <template v-for="item in data">
                    <li v-if="item.name !== 'Ostatni Akce'" :key="item.id" class="mb-2">
                        {{item.name}} - {{item.description}}
                    </li>
                </template>
            </ul>
            <get-text name="index"></get-text>
        </div>
    </div>
</template>

<script>
    import Navbar from "../components/navbar";
    import axios from "axios";
    import moment from 'moment';
    import GetText from "@/components/get-text";
    export default {
        name: "homepage",
        components: {GetText, Navbar},
        data() {
            return {
                data: [],
            }
        },
        methods: {
    
            async loadData() {
                try {
                    const response_data = await axios({
                        url: process.env.VUE_APP_SERVER + 'courses/list-edit.php',
                        headers: {
                            'content-type': 'application/x-www-form-urlencoded',
                        },
                        method: 'GET'
                    });
    
                    this.data = response_data.data.records;
    
                    if (this.changedModalId) {
                        this.changeDataInModal(this.changedModalId);
                    }
    
    
                } catch (error) {
                    console.log("error", error);
                }
            },
            week() {
                let week = moment().format('W');
                if (week % 2) {
                    return "lichý";
                } else {
                    return "sudý"
                }
                
            }
        },
        computed: {

        },
        created() {
            this.loadData();
        }
    }
</script>

<style scoped>

</style>